import { Button } from '@/components/ui/button';
import { displayCurrency, displayDate } from '@/utils/format.utils';
import type { ColumnDef } from '@tanstack/vue-table';
import { ArrowUpDown } from 'lucide-vue-next';
import { h } from 'vue';
import type { ModelOrderResponse } from '@layup/api-sdk';

export const boostRewardsTableColumns: ColumnDef<ModelOrderResponse>[] = [
  {
    accessorKey: 'orderReference',
    header: 'Order Reference',
    cell: ({ getValue }) => {
      const reference = getValue() as string;
      return h('div', reference);
    },
  },
  {
    accessorKey: 'completedAt',
    header: ({ column }) => {
      return h(
        Button,
        {
          class: '!p-0',
          variant: 'ghost',
          onClick: () => column.toggleSorting(column.getIsSorted() === 'asc'),
        },
        () => ['Completed At', h(ArrowUpDown, { class: 'ml-2 h-4 w-4' })],
      );
    },
    enableSorting: true,
    cell: ({ getValue }) => {
      const dateUpdated = getValue() as string;
      return h('div', displayDate(dateUpdated));
    },
  },
  {
    accessorKey: 'voucherCode',
    header: 'Voucher Code',
    cell: ({ getValue }) => {
      const voucherCode = getValue() as string;
      return h('div', `...${voucherCode}`);
    },
  },
  {
    accessorKey: 'voucherTotal',
    header: ({ column }) => {
      return h(
        Button,
        {
          class: '!p-0',
          variant: 'ghost',
          onClick: () => column.toggleSorting(column.getIsSorted() === 'asc'),
        },
        () => ['Voucher Total', h(ArrowUpDown, { class: 'ml-2 h-4 w-4' })],
      );
    },
    enableSorting: true,
    cell: ({ getValue }) => {
      const amount = getValue() as number;
      const displayAmount = displayCurrency(amount);
      return h('div', { class: 'text-right' }, displayAmount);
    },
  },
];
